import SEO from '@/components/base/SEO';
import SchemaOrg from '@/components/feature/SchemaOrg';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

const milestones = [
  { year: '2024', title: '平台创立', description: '黄瓜视频正式上线，致力于打造优质短视频内容平台' },
  { year: '2025', title: '快速发展', description: '日活用户突破1000万，创作者数量超过10万，完成A轮融资' },
  { year: '2025', title: '技术创新', description: '推出AI智能推荐算法，用户观看时长提升300%，获评年度最佳短视频应用' },
  { year: '2026', title: '行业领先', description: '日活用户突破5000万，创作者超过100万，成为国内领先的短视频平台之一' },
];

const honors = [
  { icon: 'ri-award-line', title: '2026年度最佳短视频平台', desc: '中国互联网协会评选' },
  { icon: 'ri-medal-line', title: '用户最喜爱APP金奖', desc: '2026移动互联网大会' },
  { icon: 'ri-shield-star-line', title: '信息安全等级保护三级', desc: '国家信息安全认证' },
  { icon: 'ri-lightbulb-line', title: '最具创新力企业', desc: '2025科技创新峰会' },
];

const faqItems = [
  { q: '黄瓜视频是免费的吗？', a: '是的，黄瓜视频完全免费！所有视频内容均可免费在线观看，无需任何付费。同时支持免费下载，让您随时随地离线观看。' },
  { q: '如何在黄瓜视频上发布内容？', a: '下载黄瓜视频APP后，注册账号即可成为创作者。点击发布按钮，上传您的视频作品，填写标题和标签后即可发布。我们欢迎每一位有才华的创作者加入！' },
  { q: '黄瓜视频支持哪些设备？', a: '黄瓜视频支持iOS和Android手机、平板设备，也可以通过电脑浏览器访问官方网站在线观看。多端观看记录自动同步，切换设备无缝衔接。' },
  { q: '视频画质支持多少分辨率？', a: '黄瓜视频支持从流畅到4K超高清多种画质选择。系统会根据您的网络状况自动推荐最佳画质，您也可以手动选择需要的清晰度。创作者可以上传最高4K分辨率的视频。' },
  { q: '如何联系黄瓜视频客服？', a: '您可以通过以下方式联系我们：官方邮箱 support@huangguavideo.com，或在APP内"我的-帮助与反馈"中提交工单，我们的客服团队会在24小时内回复您。' },
];

export default function AboutPage() {
  return (
    <>
      <SEO
        title="关于我们"
        description="黄瓜视频品牌介绍、平台荣誉与联系方式。黄瓜视频是一款备受用户喜爱的短视频平台，提供海量高清视频内容，覆盖娱乐、生活、美食、科技等丰富类目。"
        keywords="黄瓜视频,关于黄瓜视频,短视频平台,品牌介绍,联系方式"
        canonicalUrl="https://huangguavideo.com/about"
      />
      <SchemaOrg type="BreadcrumbList" data={{
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://huangguavideo.com' },
          { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://huangguavideo.com/about' },
        ],
      }} />
      <SchemaOrg type="WebPage" data={{
        name: '关于我们 - 黄瓜视频',
        description: '黄瓜视频品牌介绍、平台荣誉与联系方式',
        url: 'https://huangguavideo.com/about',
        isPartOf: { '@type': 'WebSite', name: '黄瓜视频', url: 'https://huangguavideo.com' },
      }} />
      <SchemaOrg type="FAQPage" data={{
        mainEntity: faqItems.map((item) => ({
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: { '@type': 'Answer', text: item.a },
        })),
      }} />

      <ScrollToTop />
      <Navbar />

      <main className="pt-20">
        <div className="max-w-5xl mx-auto">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <div className="px-4 md:px-6">
            {/* Brand Introduction */}
            <section className="pb-14 md:pb-20">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
                <div>
                  <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
                    品牌介绍
                  </span>
                  <h1 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-6 leading-tight">
                    让每个人都能<br />发现精彩的<span className="text-primary-500">视频世界</span>
                  </h1>
                  <p className="text-foreground-600 leading-relaxed mb-4">
                    黄瓜视频成立于2024年，是一家专注于短视频内容创作与分发的互联网平台。我们的使命是连接创作者与观众，让优质内容触达每一个人。
                  </p>
                  <p className="text-foreground-600 leading-relaxed mb-4">
                    平台汇聚了超过100万位多元化创作者，覆盖娱乐、生活、美食、科技、游戏、音乐、运动、时尚等八大内容类目，每日更新海量高清视频内容。
                  </p>
                  <p className="text-foreground-600 leading-relaxed">
                    我们始终坚持技术驱动创新，通过AI智能推荐算法，为每一位用户提供个性化的内容体验。同时，我们建立了完善的创作者扶持体系，帮助优质创作者获得更多曝光与收益。
                  </p>
                </div>
                <div className="rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20creative%20office%20space%20with%20diverse%20team%20collaborating%2C%20large%20screens%20displaying%20video%20content%2C%20warm%20natural%20lighting%2C%20open%20workspace%20design%2C%20vibrant%20and%20energetic%20atmosphere%2C%20casual%20tech%20company%20culture&width=700&height=500&seq=about-brand-image&orientation=landscape"
                    alt="黄瓜视频团队"
                    title="黄瓜视频 - 品牌团队"
                    className="w-full h-auto object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
            </section>

            {/* Milestones */}
            <section className="pb-14 md:pb-20">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
                  发展历程
                </h2>
                <p className="text-foreground-600 text-sm">从创立到现在，我们一直在成长</p>
              </div>
              <div className="relative">
                <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-200 md:-translate-x-px"></div>
                <div className="space-y-8">
                  {milestones.map((item, index) => (
                    <div key={index} className={`relative flex items-start gap-6 ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                      <div className="hidden md:block flex-1"></div>
                      <div className="absolute left-2.5 md:left-1/2 w-3 h-3 rounded-full bg-primary-500 border-4 border-background-50 md:-translate-x-1/2 z-10"></div>
                      <div className="flex-1 ml-10 md:ml-0">
                        <div className="bg-background-50 border border-background-200/70 rounded-2xl p-5 md:p-6">
                          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-bold mb-2">
                            {item.year}
                          </span>
                          <h3 className="font-heading text-foreground-900 text-lg mb-1.5">{item.title}</h3>
                          <p className="text-foreground-500 text-sm">{item.description}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* Honors */}
            <section className="pb-14 md:pb-20">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
                  平台荣誉
                </h2>
                <p className="text-foreground-600 text-sm">业界认可，用户信赖</p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {honors.map((honor, index) => (
                  <div key={index} className="bg-background-50 border border-background-200/70 rounded-2xl p-6 text-center hover:border-accent-300 transition-all duration-300">
                    <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-accent-100 flex items-center justify-center">
                      <i className={`${honor.icon} text-accent-600 text-2xl`}></i>
                    </div>
                    <h3 className="font-heading text-foreground-900 text-sm mb-2">{honor.title}</h3>
                    <p className="text-foreground-500 text-xs">{honor.desc}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* FAQ */}
            <section className="pb-14 md:pb-20">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
                  常见问题
                </h2>
                <p className="text-foreground-600 text-sm">关于黄瓜视频，你想知道的都在这里</p>
              </div>
              <div className="max-w-3xl mx-auto space-y-3">
                {faqItems.map((item, index) => (
                  <details key={index} className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden">
                    <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                      <span className="font-heading text-foreground-900 text-sm md:text-base pr-4">{item.q}</span>
                      <span className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-background-100 group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                        <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform duration-300"></i>
                      </span>
                    </summary>
                    <div className="px-5 md:px-6 pb-5 md:pb-6">
                      <p className="text-foreground-600 text-sm leading-relaxed">{item.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </section>

            {/* Contact */}
            <section className="pb-14 md:pb-20">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
                  联系我们
                </h2>
                <p className="text-foreground-600 text-sm">期待与您的交流与合作</p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 max-w-3xl mx-auto">
                <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 text-center hover:border-primary-200 transition-all duration-300">
                  <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                    <i className="ri-mail-line text-primary-600 text-xl"></i>
                  </div>
                  <h3 className="font-heading text-foreground-900 text-sm mb-1">电子邮箱</h3>
                  <p className="text-foreground-500 text-xs">support@huangguavideo.com</p>
                </div>
                <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 text-center hover:border-primary-200 transition-all duration-300">
                  <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                    <i className="ri-phone-line text-primary-600 text-xl"></i>
                  </div>
                  <h3 className="font-heading text-foreground-900 text-sm mb-1">客服电话</h3>
                  <p className="text-foreground-500 text-xs">400-888-XXXX</p>
                </div>
                <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 text-center hover:border-primary-200 transition-all duration-300">
                  <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                    <i className="ri-map-pin-line text-primary-600 text-xl"></i>
                  </div>
                  <h3 className="font-heading text-foreground-900 text-sm mb-1">公司地址</h3>
                  <p className="text-foreground-500 text-xs">北京市朝阳区科技园区</p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}